import { Observable } from 'rxjs';
import { ConfirmDialog, AlertDialog, ModalDialog, BottomSheetDialog } from '../app/shared/components/dialog/dialog.component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Injectable, ComponentRef } from '@angular/core';

@Injectable()
export class DialogFactory {

    public static TOASTY_SUCCESS = 1;
    public static TOASTY_ERROR = 2;
    public static TOASTY_INFO = 3;
    public static TOASTY_WARNING = 4;

    public static SNACK_SUCCESS = 'success';
    public static SNACK_ERROR = 'error';
    public static SNACK_INFO = 'info';
    public static SNACK_WARNING = 'warning';
    public static SNACK_NONE = 'none';

    private _dialog: MatDialog;
    private _bottomSheet: MatBottomSheet;
    private _snackBar: MatSnackBar;

    constructor(
        private _matDialog: MatDialog,
        private _matButtonSheet: MatBottomSheet,
        private _matSnackbar: MatSnackBar
    ) {
        this._dialog      = _matDialog;
        this._bottomSheet = _matButtonSheet;
        this._snackBar    = _matSnackbar;
    }

    public confirm(title: string, message: string, okLabel?, cancelLabel?): Observable<boolean> {
        let dialogRef: MatDialogRef<ConfirmDialog>;
        dialogRef = this._dialog.open(ConfirmDialog);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        if (okLabel) {
            dialogRef.componentInstance.okLabel = okLabel;
        }

        if (cancelLabel) {
            dialogRef.componentInstance.cancelLabel = cancelLabel;
        }

        return dialogRef.afterClosed();
    }

    public alert(title: string, message: string, icon?: string): Observable<boolean> {
        let dialogRef: MatDialogRef<AlertDialog>;

        dialogRef = this._dialog.open(AlertDialog);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.icon = icon;

        return dialogRef.afterClosed();
    }

    public modal(component: ComponentRef<any> | HTMLElement, options?): MatDialogRef<ModalDialog, any> {
        if (!options) {
            options = {};
        }

        options.panelClass = options.panelClass || 'no-padding-dialog';

        let dialogRef: MatDialogRef<ModalDialog>;
        dialogRef = this._dialog.open(ModalDialog, options);
        
        if (component instanceof ComponentRef) {
            dialogRef.beforeClosed().subscribe(() => {
                component.destroy();
            });

            component.instance.closeWindow = function () {
                dialogRef.close();
            };

            dialogRef.componentInstance.component = component;
        }

        if (component instanceof HTMLElement) {
            dialogRef.componentInstance.contentHTML = component;
        }

        return dialogRef;
    }

    public bottomSheet(options): MatBottomSheetRef<BottomSheetDialog, any> {
        return this._bottomSheet.open(BottomSheetDialog, options);
    }

    public snackBar(title: string, message: string, type: number) {
        let typePrefix = DialogFactory.SNACK_NONE;
        switch(type) {
            case DialogFactory.TOASTY_INFO: {
                typePrefix = DialogFactory.SNACK_INFO;
                break;
            }
            case DialogFactory.TOASTY_SUCCESS: {
                typePrefix = DialogFactory.SNACK_SUCCESS;
                break;
            }
            case DialogFactory.TOASTY_WARNING: {
                typePrefix = DialogFactory.SNACK_WARNING;
                break;
            }
            case DialogFactory.TOASTY_ERROR: {
                typePrefix = DialogFactory.SNACK_ERROR;
                break;
            }
            default: {
                typePrefix = DialogFactory.SNACK_NONE;
                break;
            }
        }

        this._snackBar.open(message, title, {
          duration: 3000,
          panelClass: [typePrefix+"-snackbar"]
        });
    }

    public snack(message: string, action: string = 'OK', type:string = DialogFactory.SNACK_NONE, options: MatSnackBarConfig = {}) {
        options.panelClass = [type+"-snackbar"];
        options.duration = options.duration || 3000;
        this._snackBar.open(message, action, options);
    }

    public toasty(title: string, message: string, type: number): void {

        this.snackBar(message, 'OK', type);

    }
}
